var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "clearfix threeStep",
      style: { height: _vm.height + "px" },
    },
    [
      _c("el-card", { staticClass: "complaint-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("div", [
              _vm._v(" 投诉编号："),
              _c("span", [
                _vm._v(_vm._s(_vm.datas.rulesForm[0].complaintCode)),
              ]),
            ]),
            _c("div"),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "left-complain-con",
            style: { height: _vm.flowHeight + "px" },
          },
          [
            _c("div", { staticClass: "leftCss" }),
            _c(
              "div",
              { staticClass: "rightCss" },
              [
                _c(
                  "el-row",
                  _vm._l(_vm.datas.rulesForm, function (form, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class:
                          _vm.datas.rulesForm.length > 1 &&
                          (((index < 2 ||
                            index == _vm.datas.rulesForm.length - 1) &&
                            _vm.isMore) ||
                            !_vm.isMore)
                            ? "formMultiple"
                            : "",
                        staticStyle: { position: "relative" },
                      },
                      [
                        ((index < 2 ||
                          index == _vm.datas.rulesForm.length - 1) &&
                          _vm.isMore) ||
                        !_vm.isMore
                          ? [
                              _vm.datas.rulesForm.length > 1
                                ? _c("div", { staticClass: "timeline" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(Number(index) + 1)),
                                    ]),
                                    _c("span"),
                                  ])
                                : _vm._e(),
                              form.isOpen
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form",
                                        {
                                          ref: "form",
                                          refInFor: true,
                                          staticClass: "form",
                                          attrs: {
                                            model: _vm.datas,
                                            rules: _vm.rules,
                                            "label-width": "220px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 10 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "投诉处理部门：",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            form.handleDeptName
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 10 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "投诉处理结果：",
                                                        rules:
                                                          _vm.rules
                                                            .handleStatus,
                                                        prop: `rulesForm.${index}.handleStatus`,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            disabled:
                                                              form.status !=
                                                                8 ||
                                                              !_vm.authority,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeSelect(
                                                                index
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              form.handleStatus,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                form,
                                                                "handleStatus",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.handleStatus",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.dealOptions,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  label:
                                                                    item.name,
                                                                  value:
                                                                    item.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 10 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "处理完成时间：",
                                                        rules:
                                                          _vm.rules.handleTime,
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        attrs: {
                                                          disabled: true,
                                                          type: "datetime",
                                                          placeholder:
                                                            "选择日期",
                                                        },
                                                        model: {
                                                          value:
                                                            form.handleTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              form,
                                                              "handleTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.handleTime",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              form.handleStatus == 1
                                                ? [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "处理结果及依据：",
                                                              rules:
                                                                _vm.rules
                                                                  .handleReason,
                                                              prop: `rulesForm.${index}.handleReason`,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                rows: 5,
                                                                "show-word-limit":
                                                                  "",
                                                                type: "textarea",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                              },
                                                              model: {
                                                                value:
                                                                  form.handleReason,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "handleReason",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.handleReason",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "被投诉人的陈述和申辩：",
                                                              rules:
                                                                _vm.rules
                                                                  .handleDefend,
                                                              prop: `rulesForm.${index}.handleDefend`,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                rows: 5,
                                                                "show-word-limit":
                                                                  "",
                                                                type: "textarea",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                              },
                                                              model: {
                                                                value:
                                                                  form.handleDefend,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "handleDefend",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.handleDefend",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "监管调查认定的基本事实：",
                                                              rules:
                                                                _vm.rules
                                                                  .handleFact,
                                                              prop: `rulesForm.${index}.handleFact`,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                rows: 5,
                                                                "show-word-limit":
                                                                  "",
                                                                type: "textarea",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                              },
                                                              model: {
                                                                value:
                                                                  form.handleFact,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "handleFact",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.handleFact",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "专家意见（若有）：",
                                                              rules:
                                                                _vm.rules
                                                                  .remark,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                rows: 5,
                                                                "show-word-limit":
                                                                  "",
                                                                type: "textarea",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                              },
                                                              model: {
                                                                value:
                                                                  form.remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : form.handleStatus == 2
                                                ? [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "驳回原因：",
                                                              rules:
                                                                _vm.rules
                                                                  .revokeReason,
                                                              prop: `rulesForm.${index}.revokeReason`,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                "show-word-limit":
                                                                  "",
                                                                rows: 5,
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                                type: "textarea",
                                                              },
                                                              model: {
                                                                value:
                                                                  form.revokeReason,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "revokeReason",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.revokeReason",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "驳回回复：",
                                                              rules:
                                                                _vm.rules
                                                                  .revokeReasonReply,
                                                              prop: `rulesForm.${index}.revokeReasonReply`,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                "show-word-limit":
                                                                  "",
                                                                rows: 5,
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                                type: "textarea",
                                                              },
                                                              model: {
                                                                value:
                                                                  form.revokeReasonReply,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "revokeReasonReply",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.revokeReasonReply",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : form.handleStatus == 3
                                                ? [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "转办部门：",
                                                              rules:
                                                                _vm.rules
                                                                  .selectId,
                                                              prop: `rulesForm.${index}.selectId`,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "select-depart-tree",
                                                              {
                                                                ref:
                                                                  "selectDepartTreeRef" +
                                                                  index,
                                                                refInFor: true,
                                                                attrs: {
                                                                  selectDisabled:
                                                                    form.status !=
                                                                      8 ||
                                                                    !_vm.authority,
                                                                  modelValue:
                                                                    _vm.selectName,
                                                                  isMultiple: false,
                                                                },
                                                                on: {
                                                                  "update:modelValue":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectName =
                                                                        $event
                                                                    },
                                                                  "update:model-value":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectName =
                                                                        $event
                                                                    },
                                                                  handleDeptType:
                                                                    (val) =>
                                                                      _vm.changeDept(
                                                                        val,
                                                                        "deptRef"
                                                                      ),
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "转办备注：",
                                                              rules:
                                                                _vm.rules
                                                                  .remark,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                "show-word-limit":
                                                                  "",
                                                                rows: 5,
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                                type: "textarea",
                                                              },
                                                              model: {
                                                                value:
                                                                  form.remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : form.handleStatus == 4
                                                ? [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "移交部门：",
                                                              rules:
                                                                _vm.rules
                                                                  .selectId,
                                                              prop: `rulesForm.${index}.selectId`,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "select-depart-tree",
                                                              {
                                                                ref:
                                                                  "selectDepartTreeRef" +
                                                                  index,
                                                                refInFor: true,
                                                                attrs: {
                                                                  selectDisabled:
                                                                    form.status !=
                                                                      8 ||
                                                                    !_vm.authority,
                                                                  modelValue:
                                                                    _vm.selectName,
                                                                  isMultiple: false,
                                                                },
                                                                on: {
                                                                  "update:modelValue":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectName =
                                                                        $event
                                                                    },
                                                                  "update:model-value":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectName =
                                                                        $event
                                                                    },
                                                                  handleDeptType:
                                                                    (val) =>
                                                                      _vm.changeDept(
                                                                        val,
                                                                        "deptRef"
                                                                      ),
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "移交备注：",
                                                              rules:
                                                                _vm.rules
                                                                  .remark,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                rows: 5,
                                                                "show-word-limit":
                                                                  "",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                                type: "textarea",
                                                              },
                                                              model: {
                                                                value:
                                                                  form.remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : form.handleStatus == 5
                                                ? [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "添加配合部门：",
                                                              rules:
                                                                _vm.rules
                                                                  .selectId,
                                                              prop: `rulesForm.${index}.selectId`,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "select-depart-tree",
                                                              {
                                                                ref:
                                                                  "selectDepartTreeRef" +
                                                                  index,
                                                                refInFor: true,
                                                                attrs: {
                                                                  selectDisabled:
                                                                    form.status !=
                                                                      8 ||
                                                                    !_vm.authority,
                                                                  modelValue:
                                                                    _vm.selectName,
                                                                  isMultiple: true,
                                                                },
                                                                on: {
                                                                  "update:modelValue":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectName =
                                                                        $event
                                                                    },
                                                                  "update:model-value":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectName =
                                                                        $event
                                                                    },
                                                                  handleDeptType:
                                                                    (val) =>
                                                                      _vm.changeDept(
                                                                        val,
                                                                        "5"
                                                                      ),
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "配合备注：",
                                                              rules:
                                                                _vm.rules
                                                                  .remark,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                rows: 5,
                                                                "show-word-limit":
                                                                  "",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                                type: "textarea",
                                                              },
                                                              model: {
                                                                value:
                                                                  form.remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : form.handleStatus == 6
                                                ? [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "移交司法/监察部门名称：",
                                                              rules:
                                                                _vm.rules
                                                                  .selectName,
                                                              prop: `rulesForm.${index}.selectId`,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                              },
                                                              model: {
                                                                value:
                                                                  form.selectId,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "selectId",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.selectId",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label: "备注：",
                                                              rules:
                                                                _vm.rules
                                                                  .remark,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                maxlength:
                                                                  "255",
                                                                rows: 5,
                                                                "show-word-limit":
                                                                  "",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                                type: "textarea",
                                                              },
                                                              model: {
                                                                value:
                                                                  form.remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : form.handleStatus == 7
                                                ? [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 20 } },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "退回原因：",
                                                              rules:
                                                                _vm.rules
                                                                  .revokeReason,
                                                              prop: `rulesForm.${index}.revokeReason`,
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                rows: 5,
                                                                maxlength:
                                                                  "255",
                                                                "show-word-limit":
                                                                  "",
                                                                disabled:
                                                                  form.status !=
                                                                    8 ||
                                                                  !_vm.authority,
                                                                type: "textarea",
                                                              },
                                                              model: {
                                                                value:
                                                                  form.revokeReason,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      form,
                                                                      "revokeReason",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.revokeReason",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm._l(
                                                form.attachments,
                                                function (item, index) {
                                                  return _c(
                                                    "el-col",
                                                    {
                                                      key: index,
                                                      attrs: { span: 20 },
                                                    },
                                                    [
                                                      form.status == 8 &&
                                                      _vm.authority
                                                        ? _c(
                                                            "el-form-item",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  item.fileTypeName
                                                                    ? item.fileTypeName +
                                                                      "："
                                                                    : "附件：",
                                                                prop:
                                                                  "attachments" +
                                                                  item.fileType,
                                                                size: "small",
                                                              },
                                                            },
                                                            [
                                                              _c("affix-msg", {
                                                                attrs: {
                                                                  docItem: item,
                                                                  docName:
                                                                    item.name,
                                                                },
                                                                on: {
                                                                  "update:docItem":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      item =
                                                                        $event
                                                                    },
                                                                  "update:doc-item":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      item =
                                                                        $event
                                                                    },
                                                                  "update:docName":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        item,
                                                                        "name",
                                                                        $event
                                                                      )
                                                                    },
                                                                  "update:doc-name":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        item,
                                                                        "name",
                                                                        $event
                                                                      )
                                                                    },
                                                                  uploadSuccess:
                                                                    _vm.uploadSuccess,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _c("affix-doc", {
                                                            staticClass:
                                                              "affixDown",
                                                            attrs: {
                                                              item: item,
                                                              name: item.fileTypeName,
                                                              labelWidth:
                                                                "220px",
                                                            },
                                                            on: {
                                                              "update:item":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  item = $event
                                                                },
                                                            },
                                                          }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              form.handleStatus == 7
                                                ? [
                                                    form.complaintSupplyVo &&
                                                    form.complaintSupplyVo.id
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 24,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-divider"
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-bottom":
                                                                          "8px",
                                                                      },
                                                                    attrs: {
                                                                      label:
                                                                        "补充提交时间：",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          form
                                                                            .complaintSupplyVo
                                                                            .supplyTime
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-bottom":
                                                                          "8px",
                                                                      },
                                                                    attrs: {
                                                                      label:
                                                                        "补充材料描述：",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          form
                                                                            .complaintSupplyVo
                                                                            .remark
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._l(
                                                              form
                                                                .complaintSupplyVo
                                                                .attachments,
                                                              function (
                                                                itm,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "el-col",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      span: 20,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "affix-doc",
                                                                      {
                                                                        staticClass:
                                                                          "affixDown",
                                                                        attrs: {
                                                                          item: itm,
                                                                          name: "补充材料附件",
                                                                          labelWidth:
                                                                            "220px",
                                                                        },
                                                                        on: {
                                                                          "update:item":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              itm =
                                                                                $event
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "imgCss" }, [
                                        form.status == 8
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/dcl.png"),
                                              },
                                            })
                                          : form.status == 1
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/ycl.png"),
                                              },
                                            })
                                          : form.status == 7
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/yth.png"),
                                              },
                                            })
                                          : form.status == 4
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/yjb.png"),
                                              },
                                            })
                                          : form.status == 3
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/yzb.png"),
                                              },
                                            })
                                          : form.status == 5
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/xhph.png"),
                                              },
                                            })
                                          : form.status == 2
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/ybh.png"),
                                              },
                                            })
                                          : _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/complaint/yyj.png"),
                                              },
                                            }),
                                      ]),
                                      index != _vm.datas.rulesForm.length - 1
                                        ? _c(
                                            "div",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeOpen(index)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "el-icon-arrow-up away",
                                                },
                                                [_vm._v("收起")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "foldBox",
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeOpen(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/img/complaint/open.png"),
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticStyle: { flex: "1" } },
                                          [_vm._v(_vm._s(form.handleDeptName))]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              _vm.dealColor(form.status),
                                              "typeCss",
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.dealType(form.status))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                            ]
                          : _vm._e(),
                        _vm.datas.rulesForm.length >= 4 &&
                        index == 2 &&
                        _vm.isMore
                          ? [
                              _vm.datas.rulesForm.length > 1
                                ? _c(
                                    "div",
                                    { staticClass: "timeline timelines" },
                                    [_c("span"), _c("span")]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "moreBox",
                                  on: { click: _vm.moreFn },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/complaint/more.png"),
                                    },
                                  }),
                                  _c("div", [
                                    _vm._v("查看更多"),
                                    _c("span", {
                                      staticClass: "el-icon-arrow-down",
                                    }),
                                  ]),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }